import { loggerCreate } from '@blaze-shared/logger-util';

export const logPageContext = loggerCreate('page_context', null, null, null);
